import axios from 'axios'

// state
export const state = {
  isLeaguesLoading: false,
  leagues: [],
}

// getters
export const getters = {
}
// mutations
export const mutations = {
  fetchLeaguesStarted(state) {
    state.isLeaguesLoading = true
  },
  fetchLeaguesSuccess(state, leagues) {
    state.leagues = leagues
    state.isLeaguesLoading = false
  },
  fetchLeaguesFailed(state) {
    state.isLeaguesLoading = false
  },
}
// actions
export const actions = {
  async fetchLeagues({ commit, state: { leagues } }) {
    if (leagues.length) {
      return leagues
    }
    try {
      commit('fetchLeaguesStarted')
      const leagues = await axios.get('leagues')
      commit('fetchLeaguesSuccess', leagues)
      return leagues
    } catch (e) {
      commit('fetchLeaguesFailed')
    }
    return leagues
  },
}
